import React, { memo, useState, useEffect, useCallback } from 'react';
import { Text, View, StyleSheet } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';

import { I18n, NavBar, CTAButton, Container, Navigation } from '../components';
import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAppointmentSlotAvailability, resetStatus } from '../airforce/scheduler/slice';

import { openCaseInfo, resetState } from '../cases/actions';
import { getAssociatedEmployer } from '../../selectors/employers';

import Cal from './scheduler/cal_patient';

const PatientSchedule = memo((props) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  useEffect(NavBar.setup(props), []);
  useEffect(() => {
    if (!__WEB__) {
      Navigation.setButtons(
        {
          leftButtons: [NavBar.buttons.done],
        },
        props.componentId
      );
    }
    props.actions.resetStatus();
    fetchData();
    props.actions.openCaseInfo(props.caseId);
    return () => {
      props.actions.resetState();
    };
  }, []);

  useEffect(() => {
    if (props.aptsRequestStatus === SUCCESS || props.aptsRequestStatus === FAILED) {
      fetchData();
    }
  }, [props.aptsRequestStatus]);

  const fetchData = useCallback(() => {
    if (!props.employer) return;
    props.actions.getAppointmentSlotAvailability({
      employerKey: props.employer.slug,
      eventType: props.eventType,
    });
  }, [props.employer, props.eventType]);

  const handleTimesChange = useCallback((selectedTimes) => {
    const selectedTime = selectedTimes.length ? selectedTimes[0] : null;
    setSelectedTime(selectedTime);
  }, []);

  function closeScreen() {
    Navigation.close(props);
  }

  const openDetailsForm = useCallback(() => {
    Navigation.showModal({
      screen: 'CreatePHARequest',
      title: 'Patient Info',
      passProps: {
        selectedDate: selectedDate,
        selectedTimes: [selectedTime],
        eventType: props.eventType,
        retainPatientState: true,
        callOnUnmount: __WEB__ ? this.closeScreen : null,
      },
    });
  }, [selectedDate, selectedTime, props.eventType]);

  return (
    <Container
      renderActivityOverlay={props.aptsSlotAvailabilityStatus === REQUESTING}
      scrollView={true}
      contentContainerStyle={{ paddingVertical: 20 }}
      errorMessage={props.aptsSlotAvailabilityError?.message}
    >
      <View style={[{ alignItems: 'center' }]}>
        <Text style={styles.contentTitle}>{props.eventType}</Text>

        <View style={{ maxWidth: 500, paddingHorizontal: 10 }}>
          {!!props.aptsSlotAvailabilityData?.available && (
            <Cal
              onSelectedDate={setSelectedDate}
              onTimesChange={handleTimesChange}
              events={null}
              slotAvailability={props.aptsSlotAvailabilityData}
              aptsSlotAvailabilityStatus={props.aptsSlotAvailabilityStatus}
              disableBlockedDays={true}
              eventType={props.eventType}
              base={props.base}
              eventTypesConfig={props.employer?.eventTypesConfiguration}
            />
          )}
        </View>
      </View>

      <View style={[{ alignItems: 'center' }]}>
        <CTAButton
          style={{ width: 200 }}
          onPress={openDetailsForm}
          label={I18n.t('auth.requestTime')}
          disabled={props.aptsSlotAvailabilityStatus !== SUCCESS || !selectedTime}
        />
      </View>
    </Container>
  );
});

const styles = StyleSheet.create({
  contentTitle: {
    ...FONT.light,
    color: COLOR.text,
    fontSize: FONT_SIZE.enormous,
    marginBottom: 10,
    textAlign: 'center',
  },
});

function mapStateToProps(state, ownProps) {
  return {
    aptsSlotAvailabilityData: state.screens.scheduler.aptsSlotAvailabilityData,
    aptsSlotAvailabilityStatus: state.screens.scheduler.aptsSlotAvailabilityStatus,
    aptsSlotAvailabilityError: state.screens.scheduler.aptsSlotAvailabilityError,
    aptsRequestStatus: state.screens.scheduler.aptsRequestStatus,
    employer: getAssociatedEmployer(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { getAppointmentSlotAvailability, resetStatus, openCaseInfo, resetState },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientSchedule);
